export const BUYER_MANAGE_STORE = {
    STORE_PROFILE: "store-profile-nav-link",
    BUYER_FORM: "buyer-form",
    EMAIL_ERROR: "email-error-msg",
};
